import React from "react";
import { FaRegCalendarAlt, FaCheckCircle, FaTimesCircle, FaHashtag } from "react-icons/fa";

const CountryView = ({ country }) => {
  if (!country) return null;

  const formatValue = (key, value) => {
    if (key === "status") return value === 1 ? "Active" : "Inactive";
    if (key === "is_deleted") return value ? "Yes" : "No";
    if (["created_at", "updated_at"].includes(key) && value) return new Date(value).toLocaleString();
    return value || "-";
  };

  const getIcon = (key, value) => {
    switch (key) {
      case "status":
        return value === 1 ? <FaCheckCircle className="text-green-500" /> : <FaTimesCircle className="text-red-500" />;
      case "created_at":
      case "updated_at":
        return <FaRegCalendarAlt className="text-gray-400" />;
      case "id":
        return <FaHashtag className="text-gray-500" />;
      default:
        return null;
    }
  };

  // Fields to show
  const mainFields = ["id", "name"];
  const statusFields = ["status", "is_deleted"];
  const dateFields = ["created_at", "updated_at"];

  const renderField = (key) => (
    <div
      key={key}
      className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition"
    >
      <div className="flex items-center gap-2">
        {getIcon(key, country[key])}
        <span className="font-semibold text-gray-700">{key.replace(/_/g, " ").toUpperCase()}</span>
      </div>
      <span
        className={`font-medium ${
          key === "status"
            ? country[key] === 1
              ? "text-green-600"
              : "text-red-600"
            : "text-gray-800"
        }`}
      >
        {formatValue(key, country[key])}
      </span>
    </div>
  );

  return (
    <div className="max-w-lg mx-auto bg-gray-50 shadow-xl rounded-2xl p-6 border border-gray-200">

      <div className="space-y-4">
        <div className="space-y-2">
          {mainFields.map(renderField)}
        </div>
        <div className="space-y-2">
          {statusFields.map(renderField)}
        </div>
        <div className="space-y-2">
          {dateFields.map(renderField)}
        </div>
      </div>
    </div>
  );
};

export default CountryView;
